import React from "react";
import Colors from "../../../../../stories/assets/Colors";
import Fonts from "../../../../../stories/assets/Fonts";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import {
  ProfileHostingIcon,
  OnlineBookingSystemIcon,
  SecuredPaymentIcon,
  Analytics,
  ChatIconRed,
  CustomerSupportIcon,
  CancelIconBlack,
} from "../../../../../constant/imagePath";
import classes from "./HowDoesPricingWorkMobile.module.css";
import { Checkbox } from "../../../../../stories/Checkbox/Checkbox";
import { Button } from "../../../../../stories/Button/Button";

export default function HowDoesPricingWorkMobile({ show, setShow }) {
  const iconsWithTitle = [
    { icon: ProfileHostingIcon, label: "Profile Hosting" },
    { icon: OnlineBookingSystemIcon, label: "Online booking system" },
    { icon: SecuredPaymentIcon, label: "Secured payment processing" },
    { icon: Analytics, label: "Analytics and insights" },
    { icon: ChatIconRed, label: "Instant messaging with students" },
    { icon: CustomerSupportIcon, label: "Customer support" },
  ];

  return (
    <>
      <style jsx>{`
        .modal-dialog {
          max-width: 100% !important;
          max-height: 100%;
        }
        .modal {
          border-radius: 0px;
        }
        .${classes.header} {
          border-bottom-color: ${Colors.neutralShadesOfGainsboro};
        }
      `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        width={"100%"}
        borderRadius={"0px"}
        modalClass={classes.modalBody}
      >
        <div className={classes.header}>
          <div onClick={() => setShow(false)}>
            <img src={CancelIconBlack} />
          </div>
          <p style={{ ...Fonts.b3, color: Colors.neutralShadesOfNero }}>
            How does pricing works?
          </p>
        </div>
        <div className={classes.modalContent}>
          {/* What We Offer */}
          <div className={classes.whatWeOffer}>
            <h5 style={{ ...Fonts.b3, color: Colors.neutralShadesOfNero }}>
              What we offer
            </h5>
            {/* List */}
            <ul>
              {iconsWithTitle?.map((item) => {
                return (
                  <li>
                    <div>
                      <img src={item?.icon} />
                    </div>
                    <p
                      style={{
                        ...Fonts.b2,
                        color: Colors.neutralShadesOfNero,
                        lineHeight: "20px",
                      }}
                    >
                      {item?.label}
                    </p>
                  </li>
                );
              })}
            </ul>
            <p
              className={classes.tagline}
              style={{
                ...Fonts.p2,
                color: Colors.neutralShadesOfNero,
              }}
            >
              Lytesnap charges <span style={{ ...Fonts.h8 }}>10%</span> of your
              listed lesson price
            </p>
          </div>
        </div>
        {/* Modal Footer */}
        <div
          className={classes.btnBox}
          style={{
            borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
          }}
        >
          <Button
            label={"Got it"}
            primary={true}
            size={"Large"}
            onClick={() => setShow(false)}
          />
        </div>
      </ModalSkeleton>
    </>
  );
}

//   <h4
//     style={{
//       ...Fonts.h4,
//       fontSize: "26px",
//       color: Colors.neutralShadesOfNero,
//     }}
//   >
//     How does pricing work?
//   </h4>
